export default class BaseExportProvider {
  static setEditorContent(editor, content) {
    editor.options.content = content;
    editor.view.updateState(editor.createState());
  }

  static exportNote() {
    throw new Error('Method exportNote not implemented');
  }
}
